<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Cash Transactions Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CashTransactionsCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Update Branch Status
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CashTransactionsCheckersQueueTable from "../../components/Kleyton/Tables/FundsTransfer/CashTransactionsCheckersQueueTable";

export default {
  page: {
    title: "Cash Transactions Checkers Queue",
    meta: [
      {
        name: "Cash Transactions Checkers Queue",
        content: window.__env.app.description
      }
    ]
  },
  components: {
    Layout,
    PageHeader,
    CashTransactionsCheckersQueueTable
  },
  data() {
    return {
      title: "Cash Transactions Checkers Queue",
      items: [
        {
          text: "Cash Transactions",
          href: "/"
        },
        {
          text: "Cash Transactions Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>
